import { useCallback, useEffect, useState } from "react";
import { isic_get_card_microservice } from "../store/api";
import { isResolvedImageSource } from "../utils/ImageFunctions";

export default function useFetchImage(pathUrl: string, imageId: string) {
  const [srcImage, setSrcImage] = useState<string>();

  const fetchImage = useCallback(async () => {
    // Already a usable source: a data URI, an absolute URL, or a bundled asset
    // path (which is what the mock fixtures hand back). Anything else is an
    // opaque image id that has to be fetched from the image microservice.
    if (isResolvedImageSource(imageId)) {
      setSrcImage(imageId);
      return;
    }

    if (imageId === undefined || imageId === "Base-profile-image") {
      setSrcImage(imageId);
      return;
    }

    try {
      const url = isic_get_card_microservice + pathUrl + imageId;
      const res = await fetch(url, { mode: "cors" });
      const imageBlob = await res.blob();
      const fileReaderInstance = new FileReader();
      fileReaderInstance.readAsDataURL(imageBlob);
      fileReaderInstance.onload = () => {
        setSrcImage(fileReaderInstance.result as string);
      };
    } catch (e) {
      console.log({ e });
      setSrcImage(undefined);
    }
  }, [isic_get_card_microservice, pathUrl, imageId]);

  useEffect(() => {
    let shouldFetch = true;
    if (shouldFetch) fetchImage();

    return () => {
      shouldFetch = false;
    };
  }, [fetchImage]);

  return srcImage;
}
